import { Component, OnInit, OnChanges, Input } from '@angular/core';
import { EventsService } from 'src/app/services/events-service/events.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { EMPTY } from 'rxjs';
import { tap } from 'rxjs/internal/operators/tap';
import { catchError } from 'rxjs/internal/operators/catchError';

@Component({
  selector: 'app-events-event-applications-card',
  templateUrl: './events-event-applications-card.component.html',
  styleUrls: ['./events-event-applications-card.component.scss']
})
export class EventsEventApplicationsCardComponent implements OnInit {

  @Input() alert;
  @Input() availableApplications;
  updateAlertMaintenanceSubscription: Subscription;

  constructor(private eventsService: EventsService,
              private snackbarService: SnackBarService) {
              }

  ngOnInit() { }

  public duallistboxOutputEventReceiver(sections) {
    const aux = new Array();
    for (const d of sections) {
      aux.push(d[1]._data);
    }
    if (aux) {
      this.alert.centerAlertApplications = aux;
      this.updateMaintenanceAlert();
    }
  }

  private updateMaintenanceAlert() {
    this.updateAlertMaintenanceSubscription = this.eventsService.updateAlertApplications(this.alert.InternalId, this.alert.centerAlertApplications).pipe(
      tap(o => this.eventsService.refreshAlert()),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

}
